<template>
    <div class="col-12">
        <div class="row no-gutters justify-content-start ml-2">
            <div class="col-11">
                <div class="row no-gutters align-items-center my-1">
                    <div class="col-4 col-md-2 col-xl-3 text-center">
                        <img :src="getImage('hollywoodSilk', 'png')" class="jockey-silks">
                    </div>
                    <div class="col-8 horse-details-wrapper my-3">
                        <div class="row no-gutters">
                            <span class="font-weight-bold font-italic horse-name">{{selectedHorse.name}}</span>
                            <img :src="getImage('bell', 'svg')" class="bell-image">
                        </div>
                        <span class="row no-gutters font-italic horse-details-text">{{selectedHorse.horseDetails}}</span>
                        <span class="row no-gutters font-italic horse-details-text">{{selectedHorse.sponsor}}</span>
                        <span class="row no-gutters font-italic horse-details-text">{{selectedHorse.breeder}}</span>
                        <span class="row no-gutters font-italic horse-details-text">{{selectedHorse.owners}}</span>
                    </div>
                </div>
                <div class="row no-gutters">
                    <div class="col-12 col-md-8 col-xl-10 horse-career-wrapper d-flex justify-content-center">
                        <table>
                            <tr>
                                <td class="flex-nowrap font-weight-bold">Total Runs:</td>
                                <td class="flex-nowrap">{{selectedHorse.totalRuns}}</td>
                                <td class="flex-nowrap font-weight-bold">Course:</td>
                                <td class="flex-nowrap">{{selectedHorse.course}}</td>
                                <td class="flex-nowrap font-weight-bold">Poly:</td>
                                <td class="flex-nowrap">{{selectedHorse.poly}}</td>
                            </tr>
                            <tr>
                                <td class="flex-nowrap font-weight-bold">Stakes:</td>
                                <td class="flex-nowrap">{{selectedHorse.stakes}}</td>
                                <td class="flex-nowrap font-weight-bold">Distance:</td>
                                <td class="flex-nowrap">{{selectedHorse.distance}}</td>
                                <td class="flex-nowrap font-weight-bold">Wet:</td>
                                <td class="flex-nowrap">{{selectedHorse.wet}}</td>
                            </tr>
                            <tr>
                                <td class="flex-nowrap font-weight-bold">Sale Price:</td>
                                <td class="flex-nowrap">{{selectedHorse.salePrice}}</td>
                                <td class="flex-nowrap font-weight-bold">C & D:</td>
                                <td class="flex-nowrap">{{selectedHorse.courseAndDistance}}</td>
                                <td class="flex-nowrap font-weight-bold">Sand:</td>
                                <td class="flex-nowrap">{{selectedHorse.sand}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row no-gutters justify-content-center">
            <div class="col-12">
                <div class="row no-gutters justify-content-space-evenly team-details-table">
                    <div style="position: relative;" class="col-12 px-1">
                        <div class="table-responsive">
                            <table class="table">
                                <thead class="thead-dark">
                                <tr>
                                    <th scope="col">DATE</th>
                                    <th scope="col">CRS</th>
                                    <th class="d-none d-xl-table-cell" scope="col">REF</th>
                                    <th scope="col">RACE</th>
                                    <th scope="col">AR</th>
                                    <th scope="col">SH</th>
                                    <th scope="col">DIST</th>
                                    <th scope="col">MR</th>
                                    <th scope="col">DRAW</th>
                                    <th scope="col">POS</th>
                                    <th scope="col">LTH</th>
                                    <th scope="col">WINNER/2nd</th>
                                    <th scope="col">JOCKEY</th>
                                    <th scope="col">WGT</th>
                                    <th scope="col">TIME</th>
                                    <th scope="col">ADJ/TM</th>
                                    <th scope="col">OB</th>
                                    <th scope="col">SP</th>
                                    <th scope="col">COMMENT</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(run, index) in selectedHorse.previousRuns" :key="index">
                                        <td scope="row">{{run.date}}</td>
                                        <td class="highlighted-table-cell">{{run.course}}</td>
                                        <td class="d-none d-xl-table-cell">{{run.referenceAndGoing}}</td>
                                        <td>{{run.race}}</td>
                                        <td>{{run.averageFieldRating}}</td>
                                        <td>{{run.equipment}}</td>
                                        <td>{{run.distance}}</td>
                                        <td class="font-weight-bold">{{run.meritRating}}</td>
                                        <td>{{run.draw}}</td>
                                        <td><img :src="getImage('wf-finishing-position-' + run.position.value)" class="finishing-position-icon" v-on:click="toggleFormGridVisibility(run.position.raceId)"></td>
                                        <td>{{run.lengthsBehind}}</td>
                                        <td class="font-italic clickable-text" v-on:click="onHorseNameClicked(run.winnerOrSecond.horseId)">{{run.winnerOrSecond.name}}</td>
                                        <td class="highlighted-table-cell clickable-text" v-on:click="onJockeyNameClicked(run.jockey.jockeyId)">{{run.jockey.name}}</td>
                                        <td>{{run.weight}}</td>
                                        <td>{{run.time}}</td>
                                        <td>{{run.adjustedTime}}</td>
                                        <td><sup>{{run.openingPrice.numerator}}</sup>&frasl;<sub>{{run.openingPrice.denominator}}</sub></td>
                                        <td><sup>{{run.startingPrice.numerator}}</sup>&frasl;<sub>{{run.startingPrice.denominator}}</sub></td>
                                        <td>{{run.comment}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex';
    import {HorseStatisticsMockData} from '../assets/mockData/horseStatistics';
    import {FormGridService} from "../services/formGrid.service";

    export default {
        name: 'HorseStatistics',
        props: {
            selectedHorse: Object,
            formGridToggleCallback: Function
        },
        methods: {
            getImage(imagePath, fileType) {
                if(fileType) return require('../assets/images/' + imagePath + '.' + fileType);
                return require('../assets/images/' + imagePath + '.svg');
            },
            toggleFormGridVisibility(raceId) {
                FormGridService.getFormGrid(raceId, () => {});
                this.formGridToggleCallback(selectedHorse);
            },
            onHorseNameClicked(horseNameId) {
                this.setSelectedHorse({});
                this.$router.push('/landing/statistics');
            },
            onJockeyNameClicked(jockeyNameId) {
                this.setSelectedJockey({});
                this.$router.push('/landing/statistics');
            },
            ...mapMutations(['setSelectedHorse', 'setSelectedJockey'])
        },
        mounted: function() {
            this.selectedHorse = HorseStatisticsMockData;
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }

    .jockey-silks {
        width: 5rem;
    }

    .bell-image {
        height: 1.7rem;
        margin-left: 0.2rem;
    }

    .horse-name {
        font-size: 1.3rem;
    }

    .highlighted-table-cell {
        background-color: #f2f2f2;
    }

    .table-responsive {
        border: 1px solid #7c7c7c !important;
        margin-bottom: 0.5rem !important;
        box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
    }

    .team-details-table {
        margin-top: 0.6rem;
    }

    .finishing-position-icon {
        width: 1.4rem;
    }

    .horse-career-wrapper {
        border: solid 2px black;
        border-radius: 4px;
        line-height: 1rem;
        padding: 0.2rem 0;
    }

    .horse-career-wrapper table {
        width: 100%;
        text-align: center;
    }

    .horse-career-wrapper td {
        font-size: 0.55rem;
    }

    .horse-details-text {
        font-size: 0.7rem;
    }

    @media (min-width: 768px) {
        .finishing-position-icon {
            width: 1.8rem;
        }
    }

    @media only screen
    and (min-device-width: 768px)
    and (max-device-width: 1024px)
    and (orientation: portrait)
    and (-webkit-min-device-pixel-ratio: 1) {
        .horse-career-wrapper td {
            font-size: 0.9rem !important;
        }
    }

    @media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
        .horse-career-wrapper td {
            font-size: 1rem;
        }

        .jockey-silks {
            width: 7rem;
        }

        .horse-name {
            font-size: 1.7rem;
        }
    }

    @media (min-width: 1200px) {
        .table td {
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
        }

        .horse-name {
            font-size: 2rem;
        }

        .bell-image {
            height: 3rem;
            margin-left: 0.5rem;
        }

        .horse-career-wrapper td {
            font-size: 1.1rem;
            line-height: 1.6rem;
            padding: 0 1rem;
        }

        .jockey-silks {
            width: 9rem;
        }

        .horse-details-text {
            font-size: 1.05rem;
        }
    }
</style>
